/**
 * Block 6 of the ICS 221-CG, in the order the sheet lists them.
 *
 * Safety and the Agency Representative print under Other Staff but are named
 * on the form, so they are first-class units rather than typed-in extras.
 */
export const checkoffUnits = [
  { id: 'supply', label: 'Supply Unit' },
  { id: 'communications', label: 'Communications Unit' },
  { id: 'time', label: 'Time Unit' },
  { id: 'documentation', label: 'Documentation Unit' },
  { id: 'safety', label: 'Safety Unit' },
  { id: 'agency_rep', label: 'Agency Representative' },
  { id: 'demobilization', label: 'Demobilization Unit' },
] as const;
